import axios from "axios";
import { processAxiosError } from "../processAxiosError";
import { ICommentReturn } from "./addComment";
import { eCommentReviewStatus } from "./interface";

export interface PatchHierarchyCommentDetails {
  activeContext: "Hierarchy";
  hierarchyId: string;
  commentId: string;
  newStatus: eCommentReviewStatus;
}
export interface PatchTlfItemCommentDetails {
  activeContext: "TlfItem";
  id: string;
  azsolId: string;
  version: number;
  commentId: string;
  newStatus: eCommentReviewStatus;
}

export type PatchCommentDetails = PatchHierarchyCommentDetails | PatchTlfItemCommentDetails;

/**
 * Update a single comment's status.
 *
 * @param backEndUrl - Base backend URL
 * @param details - Details identifying the comment and new status
 * @param controller - AbortController to cancel the request
 * @returns The updated comment wrapped in ICommentReturn
 */
export const patchCommentStatus = async (
  backEndUrl: string,
  details: PatchCommentDetails,
  controller: AbortController,
): Promise<ICommentReturn> => {
  const url =
    details.activeContext === "Hierarchy"
      ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentStatus/${details.commentId}`
      : `${backEndUrl}TlfItems/${details.id}/CommentStatus/${details.commentId}`;

  try {
    const ret = await axios.patch(
      url,
      {
        status: details.newStatus,
      },
      {
        signal: controller.signal,
      },
    );
    return {
      success: true,
      data: ret.data,
    };
  } catch (error) {
    return processAxiosError("Update comment failed", error);
  }
};
